import React from 'react'
import { object } from 'prop-types'
import { hasChangedValues, changeItemsValue } from '../public/utility/formValues'

export default class extends React.Component {
    state = {
        changedValues: {}
    }

    componentDidMount = () => {
    }

    handlerConfirm = () => {
        const { onConfirm, onClose } = this.props
        const { changedValues } = this.state
        onConfirm && onConfirm(changedValues)
        onClose && onClose()
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        return this.bChanged()
    }

    bChanged = () => {
        return hasChangedValues(this)
    }


    fieldset基本信息 = () => {
        const { initValues } = this.props
        const { changedValues } = this.state
        const values = { ...initValues, ...changedValues }
        const treeName = values.treeName
        const treeField = values.treeField
        return [
            {
                _treegrid: '', /* rowNumbers: true,  */minRows: 15,/* maxRows: 15, */ height: '100%', onSelect: ([{ data }]) => changeItemsValue(this, '', ['fatherID', 'fullName', '名称', 'id'], [data['id'], data['fullName'], data['名称'], data['id']]),
                root: { visible: true, text: '全部', icon: 'sitemap', },
                trees: [
                    { name: treeName, treeField: treeField, groupID: 'fatherID', /* sort: '排序' */ },
                ],
                columns: [
                    { _tree: treeField, minWidth: 100, flex: 1, menuDisabled: true, sortable: false, hideable: false },
                ],
                // onDoubleTap: (data) => console.log('22', data),
            }
        ]

    }

    render() {
        const { showBody: Body } = this.props

        return <Body data={this} minWidth="600"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerConfirm, disabled: !this.canSave() },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}

            fieldsets={
                [
                    { title: '', name: '', _fieldset: this.fieldset基本信息(), fullblock: true },
                ]
            }
        />
    }
}
